// GET GLOBAL PLACES
export const GET_GLOBAL_PLACES = 'GET_GLOBAL_PLACES';
export const GET_GLOBAL_PLACES_SUCCESS = 'GET_GLOBAL_PLACES_SUCCESS';
export const GET_GLOBAL_PLACES_FAILED = 'GET_GLOBAL_PLACES_FAILED';

// GET MY PLACE
export const GET_MY_PLACE = 'GET_MY_PLACE';
export const GET_MY_PLACE_SUCCESS = 'GET_MY_PLACE_SUCCESS';
export const GET_MY_PLACE_FAILED = 'GET_MY_PLACE_FAILED';

// GET PLACE TODAY BOOKING
export const GET_PLACE_TODAY_BOOKING = 'GET_PLACE_TODAY_BOOKING';
export const GET_PLACE_TODAY_BOOKING_SUCCESS = 'GET_PLACE_TODAY_BOOKING_SUCCESS';
export const GET_PLACE_TODAY_BOOKING_FAILED = 'GET_PLACE_TODAY_BOOKING_FAILED';

// GET PLACE DETAIL
export const GET_PLACE_DETAIL = 'GET_PLACE_DETAIL';
export const GET_PLACE_DETAIL_SUCCESS = 'GET_PLACE_DETAIL_SUCCESS';
export const GET_PLACE_DETAIL_FAILED = 'GET_PLACE_DETAIL_FAILED';

// CLEAR PLACE DETAIL
export const CLEAR_PLACE_DETAIL = 'CLEAR_PLACE_DETAIL';

// UPDATE PLACE
export const UPDATE_PLACE = 'UPDATE_PLACE';
export const UPDATE_PLACE_SUCCESS = 'UPDATE_PLACE_SUCCESS';
export const UPDATE_PLACE_FAILED = 'UPDATE_PLACE_FAILED';

// GET PLACE IMAGES
export const GET_PLACE_IMAGES = 'GET_PLACE_IMAGES';
export const GET_PLACE_IMAGES_SUCCESS = 'GET_PLACE_IMAGES_SUCCESS';
export const GET_PLACE_IMAGES_FAILED = 'GET_PLACE_IMAGES_FAILED';

// POST PLACE PREVIEW IMAGES
export const POST_PLACE_PREVIEW_IMAGE = 'POST_PLACE_PREVIEW_IMAGE';
export const POST_PLACE_PREVIEW_IMAGE_SUCCESS = 'POST_PLACE_PREVIEW_IMAGE_SUCCESS';
export const POST_PLACE_PREVIEW_IMAGE_FAILED = 'POST_PLACE_PREVIEW_IMAGE_FAILED';

// POST PLACE IMAGES
export const POST_PLACE_IMAGES = 'POST_PLACE_IMAGES';
export const POST_PLACE_IMAGES_SUCCESS = 'POST_PLACE_IMAGES_SUCCESS';
export const POST_PLACE_IMAGES_FAILED = 'POST_PLACE_IMAGES_FAILED';

// DELETE PLACE IMAGES
export const DELETE_PLACE_IMAGES = 'DELETE_PLACE_IMAGES';
export const DELETE_PLACE_IMAGES_SUCCESS = 'DELETE_PLACE_IMAGES_SUCCESS';
export const DELETE_PLACE_IMAGES_FAILED = 'DELETE_PLACE_IMAGES_FAILED';

// POST IMAGES FROM PLACE TO ROOMS
export const POST_IMAGES_FROM_PLACE_TO_ROOMS = 'POST_IMAGES_FROM_PLACE_TO_ROOMS';
export const POST_IMAGES_FROM_PLACE_TO_ROOMS_SUCCESS = 'POST_IMAGES_FROM_PLACE_TO_ROOMS_SUCCESS';
export const POST_IMAGES_FROM_PLACE_TO_ROOMS_FAILED = 'POST_IMAGES_FROM_PLACE_TO_ROOMS_FAILED';

export const UPDATE_PLACE_IMAGES = 'UPDATE_PLACE_IMAGES';

export const RESET_PLACE_IMAGES = 'RESET_PLACE_IMAGES';

// CHANGE POSITION IMAGES
export const CHANGE_POSITION_PLACE_IMAGES = 'CHANGE_POSITION_IMAGES';
export const CHANGE_POSITION_PLACE_IMAGES_SUCCESS = 'CHANGE_POSITION_IMAGES_SUCCESS';
export const CHANGE_POSITION_PLACE_IMAGES_FAILED = 'CHANGE_POSITION_IMAGES_FAILED';

// DELETE IMAGES ROOMS FROM PLACE
export const DELETE_IMAGES_ROOMS_FROM_PLACE = 'DELETE_IMAGES_ROOMS_FROM_PLACE';
export const DELETE_IMAGES_ROOMS_FROM_PLACE_SUCCESS = 'DELETE_IMAGES_ROOMS_FROM_PLACE_SUCCESS';
export const DELETE_IMAGES_ROOMS_FROM_PLACE_FAILED = 'DELETE_IMAGES_ROOMS_FROM_PLACE_FAILED';

// EDIT CANCEL POLICY
export const EDIT_CANCEL_POLICY = 'EDIT_CANCEL_POLICY';
export const EDIT_CANCEL_POLICY_SUCCESS = 'EDIT_CANCEL_POLICY_SUCCESS';
export const EDIT_CANCEL_POLICY_FAILED = 'EDIT_CANCEL_POLICY_FAILED';

// UPDATE PLACE SERVICE FEE
export const UPDATE_PLACE_SERVICE_FEE = 'UPDATE_PLACE_SERVICE_FEE';
export const UPDATE_PLACE_SERVICE_FEE_SUCCESS = 'UPDATE_PLACE_SERVICE_FEE_SUCCESS';
export const UPDATE_PLACE_SERVICE_FEE_FAILED = 'UPDATE_PLACE_SERVICE_FEE_FAILED';

// ADD PLACE OTHER FEE
export const ADD_PLACE_OTHER_FEE = 'ADD_PLACE_OTHER_FEE';
export const ADD_PLACE_OTHER_FEE_SUCCESS = 'ADD_PLACE_OTHER_FEE_SUCCESS';
export const ADD_PLACE_OTHER_FEE_FAILED = 'ADD_PLACE_OTHER_FEE_FAILED';

// UPDATE PLACE OTHER FEE
export const UPDATE_PLACE_OTHER_FEE = 'UPDATE_PLACE_OTHER_FEE';
export const UPDATE_PLACE_OTHER_FEE_SUCCESS = 'UPDATE_PLACE_OTHER_FEE_SUCCESS';
export const UPDATE_PLACE_OTHER_FEE_FAILED = 'UPDATE_PLACE_OTHER_FEE_FAILED';

// DELETE PLACE OTHER FEE
export const DELETE_PLACE_OTHER_FEE = 'DELETE_PLACE_OTHER_FEE';
export const DELETE_PLACE_OTHER_FEE_SUCCESS = 'DELETE_PLACE_OTHER_FEE_SUCCESS';
export const DELETE_PLACE_OTHER_FEE_FAILED = 'DELETE_PLACE_OTHER_FEE_FAILED';

// EDIT POLICY RECEIVE ROOM
export const EDIT_POLICY_RECEIVE_ROOM = 'EDIT_POLICY_RECEIVE_ROOM';
export const EDIT_POLICY_RECEIVE_ROOM_SUCCESS = 'EDIT_POLICY_RECEIVE_ROOM_SUCCESS';
export const EDIT_POLICY_RECEIVE_ROOM_FAILED = 'EDIT_POLICY_RECEIVE_ROOM_FAILED';

// RESET PLACE DETAILS
export const RESET_PLACE_DETAILS = 'RESET_PLACE_DETAILS';

// PUT PLACE SERVICES EDIT
export const EDIT_PLACE_SERVICES = 'EDIT_PLACE_SERVICES';
export const EDIT_PLACE_SERVICES_SUCCESS = 'EDIT_PLACE_SERVICES_SUCCESS';
export const EDIT_PLACE_SERVICES_FAILED = 'EDIT_PLACE_SERVICES_FAILED';

// EDIT PLACE PARKING SERVICE
export const EDIT_PLACE_PARKING_SERVICE = 'EDIT_PLACE_PARKING_SERVICE';
export const EDIT_PLACE_PARKING_SERVICE_SUCCESS = 'EDIT_PLACE_PARKING_SERVICE_SUCCESS';
export const EDIT_PLACE_PARKING_SERVICE_FAILED = 'EDIT_PLACE_PARKING_SERVICE_FAILED';

// EDIT POLICY DEPOSIT
export const EDIT_POLICY_DEPOSIT = 'EDIT_POLICY_DEPOSIT';
export const EDIT_POLICY_DEPOSIT_SUCCESS = 'EDIT_POLICY_DEPOSIT_SUCCESS';
export const EDIT_POLICY_DEPOSIT_FAILED = 'EDIT_POLICY_DEPOSIT_FAILED';

// EDIT POLICY SMOKE AND PET
export const EDIT_POLICY_SMOKE_AND_PET = 'EDIT_POLICY_SMOKE_AND_PET';
export const EDIT_POLICY_SMOKE_AND_PET_SUCCESS = 'EDIT_POLICY_SMOKE_AND_PET_SUCCESS';
export const EDIT_POLICY_SMOKE_AND_PET_FAILED = 'EDIT_POLICY_SMOKE_AND_PET_FAILED';

// EDIT POLICY CURFEW
export const EDIT_POLICY_CURFEW = 'EDIT_POLICY_CURFEW';
export const EDIT_POLICY_CURFEW_SUCCESS = 'EDIT_POLICY_CURFEW_SUCCESS';
export const EDIT_POLICY_CURFEW_FAILED = 'EDIT_POLICY_CURFEW_FAILED';

// EDIT OTHER POLICY
export const EDIT_OTHER_POLICY = 'EDIT_OTHER_POLICY';
export const EDIT_OTHER_POLICY_SUCCESS = 'EDIT_OTHER_POLICY_SUCCESS';
export const EDIT_OTHER_POLICY_FAILED = 'EDIT_OTHER_POLICY_FAILED';

// GET LIST ROOM OF PLACE
export const GET_LIST_ROOM_OF_PLACE = 'GET_LIST_ROOM_OF_PLACE';
export const GET_LIST_ROOM_OF_PLACE_SUCCESS = 'GET_LIST_ROOM_OF_PLACE_SUCCESS';
export const GET_LIST_ROOM_OF_PLACE_FAILED = 'GET_LIST_ROOM_OF_PLACE_FAILED';

// CLEAR LIST ROOM OF PLACE
export const CLEAR_LIST_ROOM_OF_PLACE = 'CLEAR_LIST_ROOM_OF_PLACE';

// GET ROOM FACILITIES
export const GET_ROOM_FACILITIES = 'GET_ROOM_FACILITIES';
export const GET_ROOM_FACILITIES_SUCCESS = 'GET_ROOM_FACILITIES_SUCCESS';
export const GET_ROOM_FACILITIES_FAILED = 'GET_ROOM_FACILITIES_FAILED';

// ADD ROOM FACILITIES
export const ADD_ROOM_FACILITIES = 'ADD_ROOM_FACILITIES';
export const ADD_ROOM_FACILITIES_SUCCESS = 'ADD_ROOM_FACILITIES_SUCCESS';
export const ADD_ROOM_FACILITIES_FAILED = 'ADD_ROOM_FACILITIES_FAILED';

// CREATE NEW PLACE
export const CREATE_NEW_PLACE = 'CREATE_NEW_PLACE';
export const CREATE_NEW_PLACE_SUCCESS = 'CREATE_NEW_PLACE_SUCCESS';
export const CREATE_NEW_PLACE_FAILED = 'CREATE_NEW_PLACE_FAILED';

// UPDATE NUMBER AVAILABLE ROOM
export const UPDATE_NUMBER_AVAILABLE_ROOM = 'UPDATE_NUMBER_AVAILABLE_ROOM';
export const UPDATE_NUMBER_AVAILABLE_ROOM_SUCCESS = 'UPDATE_NUMBER_AVAILABLE_ROOM_SUCCESS';
export const UPDATE_NUMBER_AVAILABLE_ROOM_FAILED = 'UPDATE_NUMBER_AVAILABLE_ROOM_FAILED';

// ADD IMAGE TO PLACE PUBLIC IMAGES
export const ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES = 'ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES';
export const ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_SUCCESS = 'ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_SUCCESS';
export const ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_FAILED = 'ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_FAILED';

// DELETE IMAGE FROM PLACE PUBLIC IMAGES
export const DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES = 'DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES';
export const DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_SUCCESS = 'DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_SUCCESS';
export const DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_FAILED = 'DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_FAILED';

// UPDATE PLACE VIDEO
export const UPDATE_PLACE_VIDEO = 'UPDATE_PLACE_VIDEO';
export const UPDATE_PLACE_VIDEO_SUCCESS = 'UPDATE_PLACE_VIDEO_SUCCESS';
export const UPDATE_PLACE_VIDEO_FAILED = 'UPDATE_PLACE_VIDEO_FAILED';

// DELETE PLACE VIDEO
export const DELETE_PLACE_VIDEO = 'DELETE_PLACE_VIDEO';
export const DELETE_PLACE_VIDEO_SUCCESS = 'DELETE_PLACE_VIDEO_SUCCESS';
export const DELETE_PLACE_VIDEO_FAILED = 'DELETE_PLACE_VIDEO_FAILED';

// UPDATE CLOSE OPEN ROOM
export const UPDATE_CLOSE_OPEN_ROOM = 'UPDATE_CLOSE_OPEN_ROOM';
export const UPDATE_CLOSE_OPEN_ROOM_SUCCESS = 'UPDATE_CLOSE_OPEN_ROOM_SUCCESS';
export const UPDATE_CLOSE_OPEN_ROOM_FAILED = 'UPDATE_CLOSE_OPEN_ROOM_FAILED';

// UPDATE PRICE ROOM
export const UPDATE_PRICE_ROOM = 'UPDATE_PRICE_ROOM';
export const UPDATE_PRICE_ROOM_SUCCESS = 'UPDATE_PRICE_ROOM_SUCCESS';
export const UPDATE_PRICE_ROOM_FAILED = 'UPDATE_PRICE_ROOM_FAILED';

// GET PLACE PRICE TYPES
export const GET_PLACE_PRICE_TYPES = 'GET_PLACE_PRICE_TYPES';
export const GET_PLACE_PRICE_TYPES_SUCCESS = 'GET_PLACE_PRICE_TYPES_SUCCESS';
export const GET_PLACE_PRICE_TYPES_FAILED = 'GET_PLACE_PRICE_TYPES_FAILED';

// ADD PLACE PRICE TYPES
export const ADD_PLACE_PRICE_TYPES = 'ADD_PLACE_PRICE_TYPES';
export const ADD_PLACE_PRICE_TYPES_SUCCESS = 'ADD_PLACE_PRICE_TYPES_SUCCESS';
export const ADD_PLACE_PRICE_TYPES_FAILED = 'ADD_PLACE_PRICE_TYPES_FAILED';

// DELETE PLACE PRICE TYPES
export const DELETE_PLACE_PRICE_TYPES = 'DELETE_PLACE_PRICE_TYPES';
export const DELETE_PLACE_PRICE_TYPES_SUCCESS = 'DELETE_PLACE_PRICE_TYPES_SUCCESS';
export const DELETE_PLACE_PRICE_TYPES_FAILED = 'DELETE_PLACE_PRICE_TYPES_FAILED';

// EDIT PLACE PRICE TYPES
export const EDIT_PLACE_PRICE_TYPES = 'EDIT_PLACE_PRICE_TYPES';
export const EDIT_PLACE_PRICE_TYPES_SUCCESS = 'EDIT_PLACE_PRICE_TYPES_SUCCESS';
export const EDIT_PLACE_PRICE_TYPES_FAILED = 'EDIT_PLACE_PRICE_TYPES_FAILED';

// UPDATE CHILDREN AND EXTRA BED POLICY
export const UPDATE_CHILDREN_AND_EXTRA_BED_POLICY = 'UPDATE_CHILDREN_AND_EXTRA_BED_POLICY';
export const UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_SUCCESS = 'UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_SUCCESS';
export const UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_FAILED = 'UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_FAILED';

// UPLOAD PLACE CONTRACT
export const UPLOAD_PLACE_CONTRACT = 'UPLOAD_PLACE_CONTRACT';
export const UPLOAD_PLACE_CONTRACT_SUCCESS = 'UPLOAD_PLACE_CONTRACT_SUCCESS';
export const UPLOAD_PLACE_CONTRACT_FAILED = 'UPLOAD_PLACE_CONTRACT_FAILED';

// ADD PLACE FAVORITE
export const ADD_PLACE_FAVORITE = 'ADD_PLACE_FAVORITE';
export const ADD_PLACE_FAVORITE_SUCCESS = 'ADD_PLACE_FAVORITE_SUCCESS';
export const ADD_PLACE_FAVORITE_FAILED = 'ADD_PLACE_FAVORITE_FAILED';

// DELETE PLACE FAVORITE
export const DELETE_PLACE_FAVORITE = 'DELETE_PLACE_FAVORITE';
export const DELETE_PLACE_FAVORITE_SUCCESS = 'DELETE_PLACE_FAVORITE_SUCCESS';
export const DELETE_PLACE_FAVORITE_FAILED = 'DELETE_PLACE_FAVORITE_FAILED';
